import React from 'react';
import { Controller } from 'react-hook-form';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import classes from './SelectInputRadioButton.module.scss';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

const SelectInputRadioButton = ({
    optionsNameKey,
    optionsIdKey = 'id',
    validation,
    input,
    errors,
    control,
    className = '',
    options = [],
    defaultValue = '',
    placeholder = '',
    horizontal = false,
    showError = true,
    optionsType = 'object',
    ...props
}) => {
    return (
        <>
            <Box sx={{ minWidth: 120 }} className={classes['select-input-wrapper']}>
                <FormControl
                    fullWidth
                    error={errors[input.name]}
                    {...props}
                    className={`row m-0 ${horizontal ? 'row d-flex flex-row' : 'd-flex flex-column'}`}>
                    <label htmlFor={input.id} className={`${horizontal ? 'col-12 col-xl-4' : 'ps-0 pb-1 d-flex align-items-center gap-3'} `}>
                        {input.label}
                        {showError && errors[input.name] && (
                            <p className={classes['validation']}>*This field is required</p>
                        )}
                    </label>

                    <Controller
                        render={({ field }) => (
                            <RadioGroup
                                {...field}
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                defaultValue={defaultValue}
                                row
                                className={classes['radio-group']}
                            >
                                {options.map((opt) => (
                                    <div className={classes['radio-wrapper']}>
                                        {optionsType === 'array' ? (
                                            <FormControlLabel
                                                value={opt}
                                                key={opt}
                                                control={<Radio />}
                                                label={opt}
                                            />
                                        ) : (
                                            <FormControlLabel
                                                value={opt[optionsIdKey]}
                                                key={opt[optionsIdKey]}
                                                control={<Radio />}
                                                label={optionsNameKey ? opt[optionsNameKey] : opt.name}
                                            />
                                        )}

                                        <span>{opt.description}</span>
                                    </div>
                                ))}
                            </RadioGroup>
                        )}
                        name={input.name}
                        control={control}
                        rules={validation}
                        defaultValue={defaultValue}
                    />
                </FormControl>

            </Box>
        </>
    );
};

export default SelectInputRadioButton;